import React from "react";

const ICONS = {
  loading: "↻",
  success: "✓",
  sync: "⇄",
  warning: "!",
  error: "!",
};

export default function MCResponseCard({ visible = false, type = "loading", title = "", detail = "", className = "" }) {
  return (
    <div
      className={`mc-orderResponse ${visible ? "is-visible" : ""} is-${type} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="mc-orderResponse__icon" aria-hidden="true">{ICONS[type] || "•"}</div>
      <div>
        <strong>{title}</strong>
        {detail ? <span>{detail}</span> : null}
      </div>
    </div>
  );
}
